import LandingLayout from "../../layout/LandingPage/LandingPage";
import Poster from "./components/Poster";
import StatsCard from "./components/StatsCard";
import ThirdPoster from "./components/ThirdPoster";
import EmailSubscription from "./components/EmailSubscription";
import BlogSection from "./blogs/blog-section";
import BuyCouponSection from "./components/buy-coupon-section";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import {useEffect, useState} from "react";
import ViewCouponCodeModal from "../../Modals/view-coupon-code-modal";
import AdvertisementSection from "./components/advertisement-section";
import TryDemoSection from "./components/try-demo";
import LearnerReviews from "./components/learner-reviews";
import AdvanceLearning from "./components/advance-learning";
import FAQSection from "./components/faq-section";
import FooterPracticeBanner from "./components/footer-practice-banner";
import SocialMediaSection from "./components/social-media-section";

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

export default function LandingPage({className, ...props}) {
    const {user_email, coupon_id} = useParams()
    const query = useQuery();
    const payment_intent = query.get("payment_intent");
    const redirect_status = query.get("redirect_status");
    const [isOpen, setOpen] = useState(false);
    const navigate = useNavigate();
    useEffect(() => {
        if (redirect_status !== "succeeded") {
            navigate("/")
            return;
        }
        setOpen(true)
    }, [redirect_status])
    return (
        <LandingLayout>
            <ViewCouponCodeModal
                isOpen={isOpen}
                setOpen={setOpen}
                email={user_email}
                coupon_id={coupon_id}
                paymentIntent={payment_intent}
            />
            <Poster/>

            <StatsCard/>
            {/*<CounterSection purchaseStatus={purchaseStatus} handleClick={handleClick} />*/}
            {/*<SecondPoster />*/}
            <BuyCouponSection/>
            <AdvertisementSection/>
            <TryDemoSection/>
            <LearnerReviews/>
            <AdvanceLearning/>
            <ThirdPoster/>
            <BlogSection/>
            <FAQSection/>
            <FooterPracticeBanner/>
            <SocialMediaSection />
        </LandingLayout>

    )
}
